import { combineReducers } from 'redux';
import { list } from './list/list.reducer';
import { edit } from './edit/edit.reducer';
import { create } from './create/create.reducer';
import { GET_ALL_PROCESS_STATUSES_SUCCEEDED } from './process-status.actions';
import { EDIT_PROCESS_STATUS_SUCCEEDED, DELETE_PROCESS_STATUS_SUCCEEDED } from './edit/edit.actions';
import { CREATE_PROCESS_STATUS_SUCCEEDED } from './create/create.actions';
import { AppInjector } from '../../app-injector';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash';

const all = (state = { fetched: false, items: [] }, action) => {
  switch (action.type) {
    case CREATE_PROCESS_STATUS_SUCCEEDED:
      return {
        fetched: false,
        items: [...state.items]
      };
    case EDIT_PROCESS_STATUS_SUCCEEDED:
      return {
        fetched: false,
        items: [...state.items]
      };
    case DELETE_PROCESS_STATUS_SUCCEEDED:
      return {
        fetched: false,
        items: [...state.items]
      };
    case GET_ALL_PROCESS_STATUSES_SUCCEEDED:
      const activatedRoute = AppInjector.get(ActivatedRoute);
      const url = activatedRoute.snapshot.url;
      if (activatedRoute.snapshot.queryParams.filter_order_status) {
        const status = activatedRoute.snapshot.queryParams.filter_order_status.split(',');
        return {
          fetched: true,
          items: _.map(action.data, item => {
            const result = _.find(status, i => parseInt(i) === item.getId());
            if (result) {
              return _.assign(item, {
                isChecked: true
              });
            }
            return _.assign(item, {
              isChecked: false
            });
          })
        };
      } else if (activatedRoute.snapshot.queryParams.constraints) {
        let filters = JSON.parse(activatedRoute.snapshot.queryParams.constraints);
        if (filters['process_statuses']) {
          const status = filters['process_statuses'].split(',');
          return {
            fetched: true,
            items: _.map(action.data, item => {
              const result = _.find(status, i => parseInt(i) === item.getId());
              if (result) {
                return _.assign(item, {
                  isChecked: true
                });
              }
              return _.assign(item, {
                isChecked: false
              });
            })
          };
        }
        return {
          fetched: true,
          items: [...action.data]
        };
      } else {
        return {
          fetched: true,
          items: [...action.data]
        };
      }
    default:
      return state;
  }
};
export const ProcessStatus = combineReducers({
  list,
  edit,
  create,
  all
});
